import { Injectable } from "@angular/core";
import { NestApiProvider } from "../../nest-api";
import { Observable } from "rxjs";

@Injectable()
export class EmergencyContactApi {
  private service: string = '';
  private model: string = 'EmergencyContact';
  constructor(
    private nestApiProvider: NestApiProvider
  ) {

  }

  getContact(): Observable<any> {
    const method: string = 'GET';
    const func: string = 'getContacts';
    const params = {};
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, params, urlParams, body);
  }

  getAllContact(): Observable<any> {
    const method: string = 'GET';
    const func: string = 'getAllContact';
    const params = {};
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, params, urlParams, body);
  }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/emergency-contact.api.ts